import styles from './programme-back-arrow.module.scss'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ProgremmeBackArrowSvgIcon } from 'src/component/util/images'

interface BackArrowProps {
  text?: string
  backTo?: string
}
export const BackArrow = ({ text, backTo }: BackArrowProps): React.ReactElement => {
  const navigate = useNavigate()

  const handleBackClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    e.stopPropagation()

    if (backTo) {
      navigate(backTo)
    } else {
      window.history.back()
    }
  }

  return (
    <button type="button" onClick={handleBackClick} className={styles.container} style={{ cursor: 'pointer' }}>
      <BackArrowContent text={text} />
    </button>
  )
}
const BackArrowContent = ({ text }: { text?: string }): React.ReactElement => {
  return (
    <div className="flex items-center">
      <ProgremmeBackArrowSvgIcon className={styles.arrow} />
      <span className={`pl-2 font-roboto-condensed text-sm leading-5 tracking-[0.25px] ${styles.text}`}>{text ?? 'Back'}</span>
    </div>
  )
}
